export const getMatchListEndpoint = '/dashboard/listMatchSupersix/dashboard-superSix-listSuperSix';

export const postMatchSixEndpoint = '/dashboard/inGameRewardsEventSupersix/dashboard-superSix-publishInGameRewardsEventSupersix';
